import React, { useEffect, useState } from 'react';
import { Users, AlertTriangle } from 'lucide-react';
import api from '@/lib/api';

// Indian number words: 33 lakh, 4.2 crore.
const people = (n) => (n >= 1e7 ? `${(n / 1e7).toFixed(1).replace(/\.0$/, '')} crore`
  : n >= 1e5 ? `${(n / 1e5).toFixed(1).replace(/\.0$/, '')} lakh` : n.toLocaleString('en-IN'));

/** How many people match the ad, from Meta (services/audience.py), with advice when that doesn't
 * suit the budget. Shows nothing when Meta isn't connected. */
export default function AudienceEstimate({ campaignId, variantId, dailyPaise }) {
  const [est, setEst] = useState(null);
  useEffect(() => {
    if (!campaignId || !variantId) return undefined;
    // Wait for the budget slider to settle; the server keeps each audience's answer, so this is cheap.
    const t = setTimeout(() => {
      api.get(`/api/campaigns/${campaignId}/audience-estimate`, { params: { variant_id: variantId, daily_paise: dailyPaise } })
        .then(({ data }) => setEst(data)).catch(() => setEst(null));
    }, 500);
    return () => clearTimeout(t);
  }, [campaignId, variantId, dailyPaise]);

  if (!est?.available || !est.upper) return null;
  return (
    <div className="mb-6 space-y-2" data-testid="audience-estimate">
      <div className="p-3 rounded-xl bg-card border-2 border-ink/20 text-sm flex items-start gap-2.5">
        <Users className="w-4 h-4 shrink-0 mt-0.5" aria-hidden="true" />
        <div>
          <p><b>About {people(est.lower)} to {people(est.upper)} people</b> match your ad{est.summary ? ` in ${est.summary}` : ''}.</p>
          {est.interests?.length > 0 && (
            <p className="text-xs text-muted-foreground mt-0.5">Interested in: {est.interests.join(', ')}. Meta may reach beyond these when it finds people likely to respond.</p>
          )}
        </div>
      </div>
      {est.warning && (
        <div className="p-3 rounded-xl bg-amber-500/10 border-2 border-amber-500/40 text-sm flex items-start gap-2" data-testid="audience-warning">
          <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5 text-amber-700 dark:text-amber-400" aria-hidden="true" />
          <span>{est.advice}</span>
        </div>
      )}
    </div>
  );
}
